import { Typography } from "antd";
import React from "react";

type Props = {
  children: React.ReactNode;
  title: string;
  description?: string;
};

const ProcessTitle = ({ children, title, description }: Props) => {
  return (
    <>
      <div style={{ marginTop: 10, marginBottom: 40 }}>
        <Typography.Title data-cy="withdraw-process-step-title" level={4}>
          {title}
        </Typography.Title>

        {description && <Typography.Text>{description}</Typography.Text>}
      </div>
      {children}
    </>
  );
};

export default ProcessTitle;
